import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { GoToWishlistPageHeaderWidgetDefinition } from "@apps/wishlist/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";
import {
    parseOptionalBooleanDataAttr,
    parseStringDataAttr,
} from "@ui-utils/Injector/utils";

import { LoggerInterface } from "@interfaces/LoggerInterface";

const HEART_COLOR_DATA_ATTR = "gw-heart-color";

class GoToWishlistPageHeaderWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start() {
        this.logger.debug("GoToWishlistPageHeaderWidgetInjector.start", {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger.debug(
                "GoToWishlistPageHeaderWidgetInjector found placeholder",
                { placeholder }
            );

            const heartColor = parseStringDataAttr(
                placeholder,
                HEART_COLOR_DATA_ATTR
            );

            void (async () => {
                const GoToWishlistPageHeaderWidget =
                    await this.dynamicImportManager.importDefault(
                        GoToWishlistPageHeaderWidgetDefinition,
                        true
                    );

                const widget = new GoToWishlistPageHeaderWidget(
                    {
                        target: placeholder,
                        heartColor: heartColor || "",
                        isWidgetShadowRootEnabled: parseOptionalBooleanDataAttr(
                            placeholder,
                            WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                        ),
                    },
                    this.logger
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        WISHLIST_WIDGET_NAMES.GO_TO_WISHLIST_PAGE_HEADER_WIDGET
                    )
                );

                dispatchSdkEvent(
                    new WidgetInjectedSdkEvent(
                        WISHLIST_WIDGET_NAMES.GO_TO_WISHLIST_PAGE_HEADER_WIDGET
                    )
                );
            })();
        });
    }
}

export default GoToWishlistPageHeaderWidgetInjector;
